import React from 'react';
import { ShieldCheck, Lock, RotateCcw, Clock } from 'lucide-react';
import { Button } from '../ui/Shared';
export function GuaranteeSection() {
  return <section id="garantia" className="py-24 bg-surface" data-id="element-202">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-203">
        <div className="scale-in bg-gradient-to-br from-secondary to-accent/5 border-2 border-accent/30 rounded-[20px] p-10 md:p-14 text-center relative overflow-hidden" data-id="element-204">
          <div className="w-28 h-28 bg-gradient-gold rounded-full flex flex-col items-center justify-center mx-auto mb-8 shadow-[0_8px_32px_rgba(232,160,32,0.3)]" data-id="element-205">
            <span className="font-playfair text-4xl font-black text-primary leading-none" data-id="element-206">
              7
            </span>
            <span className="text-[10px] font-extrabold text-primary tracking-widest uppercase mt-1" data-id="element-207">
              días de garantía
            </span>
          </div>

          <h2 className="font-playfair text-3xl font-black mb-4 text-text-light" data-id="element-208">
            "¿Cómo saber si me ayuda?"
            <br data-id="element-209" />
            <span className="text-accent" data-id="element-210">Pruébalo sin riesgo.</span>
          </h2>

          <p className="text-base text-text-muted leading-relaxed max-w-[580px] mx-auto mb-8" data-id="element-211">
            Sé que ya probaste remedios, medicamentos y consejos que no
            funcionaron. Sé que piensas <em data-id="element-212">"ojalá me ayude"</em>. Por eso
            tienes 7 días completos para aplicar el protocolo. Si sientes que no
            fue lo que esperabas, te devuelvo el dinero completo. Sin preguntas,
            sin procesos largos, sin drama. Punto.
            <br data-id="element-213" />
            <br data-id="element-214" />
            Ofrezco esta garantía porque más de 850 personas ya lo aplicaron — y
            porque la confianza se gana, no se exige.
          </p>

          <div className="flex justify-center gap-6 md:gap-8 flex-wrap mb-9" data-id="element-215">
            <div className="flex flex-col items-center gap-2" data-id="element-216">
              <ShieldCheck className="w-7 h-7 text-accent" data-id="element-217" />
              <span className="text-xs text-text-muted" data-id="element-218">100% Protegido</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-219">
              <Lock className="w-7 h-7 text-accent" data-id="element-220" />
              <span className="text-xs text-text-muted" data-id="element-221">Pago Seguro</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-222">
              <RotateCcw className="w-7 h-7 text-accent" data-id="element-223" />
              <span className="text-xs text-text-muted" data-id="element-224">
                Devolución Sin Preguntas
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-225">
              <Clock className="w-7 h-7 text-accent" data-id="element-226" />
              <span className="text-xs text-text-muted" data-id="element-227">7 Días de Plazo</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}